import { DataNotFound } from '../../../CommonComponents/DataNotFound';


const NaturalHeritage = () => {

  return (
    <DataNotFound />
  );
};

export default NaturalHeritage;
